import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useState,
} from "react";

export type IActionConfirmModal = {
  onConfirm: () => void;
  description: string;
  title: string;
};

export const ConfirmModalContext = createContext<{
  state?: IActionConfirmModal;
  setState: Dispatch<SetStateAction<IActionConfirmModal | undefined>>;
}>({
  state: undefined,
  setState: undefined as any as Dispatch<
    SetStateAction<IActionConfirmModal | undefined>
  >,
});

export const ConfirmModalProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, setState] = useState<IActionConfirmModal>();

  return (
    <ConfirmModalContext.Provider value={{ state, setState }}>
      {children}
    </ConfirmModalContext.Provider>
  );
};
